module.exports = "<div class=\"centerVert\">\n    <span class=\"crs-pointer header-language-switcher\" ng-click=\"languageSwitcherCtrl.openModal('language-switcher')\">\n        <span class=\"text-grey-2 font-light text-m mlr5 ng-binding\" connectqa-settings=\"language\">{{languageSwitcherCtrl.Language}}</span>\n        <span class=\"inline-block icon language-switcher icon-grey-2 icon-xxs top-1\"></span>\n    </span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/header/language-switcher/language-switcher.html
// module id = aMXR
// module chunks = 0